// MF-528 — Catalogue of KNOWN feature flags. Documents what each flag does so admins toggle them
// with context. The value lives in settings.featureFlag.<key>; flags NOT in this list are "custom"
// flags an admin created. A flag only has an effect if application code reads its key — this
// catalogue is the source of truth for the ones that do.
export const FEATURE_FLAG_CATALOG = [
  {
    key: 'showDashboard',
    label: 'Home dashboard (Students, Parents, Teachers)',
    description:
      'Shows the assessment dashboard on the home (growth journey, skills snapshot, teacher widgets). Off by default; parents always see their children list.'
  },
  {
    key: 'showFeed',
    label: 'Activity feed',
    description: 'Shows the activity Feed on the home landing.'
  },
  {
    key: 'showLCLevelsElements',
    label: 'Learning Continuum reference elements',
    description:
      'Shows the curriculum reference (Organising Elements / Key Skills) on Learning Continuum level columns.'
  },
  {
    key: 'allowReuseUserCodes',
    label: 'Allow reusing user codes',
    description: 'Permits creating a user with a code that was used before.'
  },
  {
    key: 'usePKCEAuth',
    label: 'PKCE authentication',
    description: 'Uses the PKCE flow for SSO authentication.'
  }
]

export const CATALOG_KEYS = new Set(FEATURE_FLAG_CATALOG.map((f) => f.key))
